/**
 * Context block for overdue task chat replies (factual lines only).
 * @param {{ task?: { name?: string, status?: string, endDate?: string|null }, pillarName?: string, taskForceName?: string }} param0
 */
export function buildOverdueTaskReplyPreview({ task, pillarName, taskForceName }) {
    const name = task?.name || 'Task';
    const status = task?.status || '—';
    const due = task?.endDate || '—';
    const pillar = pillarName || 'Pillar';
    const tf = taskForceName || 'Task force';
    return `Overdue task: ${name}
Status: ${status}
Due: ${due}
Pillar: ${pillar}
Task force: ${tf}`;
}
